module.exports = __webpack_public_path__ + "img/gun-sight.d855caca.png";